import React from "react";

const Skills = () => {
  return (
    <section id="skills">
      <figure>
        <svg
          enableBackground="new 0 0 511 511"
          version="1.1"
          viewBox="0 0 511 511"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m39.5 103c1.97 0 3.91-0.8 5.3-2.2 1.4-1.39 2.2-3.33 2.2-5.3s-0.8-3.91-2.2-5.3c-1.39-1.4-3.33-2.2-5.3-2.2s-3.91 0.8-5.3 2.2c-1.4 1.39-2.2 3.33-2.2 5.3s0.8 3.91 2.2 5.3c1.39 1.4 3.33 2.2 5.3 2.2z" />
          <path d="m63.5 103c1.97 0 3.91-0.8 5.3-2.2 1.4-1.39 2.2-3.33 2.2-5.3s-0.8-3.91-2.2-5.3c-1.39-1.4-3.33-2.2-5.3-2.2s-3.91 0.8-5.3 2.2c-1.4 1.39-2.2 3.33-2.2 5.3s0.8 3.91 2.2 5.3c1.39 1.4 3.33 2.2 5.3 2.2z" />
          <path d="m87.5 103c1.97 0 3.91-0.8 5.3-2.2 1.4-1.39 2.2-3.33 2.2-5.3s-0.8-3.91-2.2-5.3c-1.39-1.4-3.33-2.2-5.3-2.2s-3.91 0.8-5.3 2.2c-1.4 1.39-2.2 3.33-2.2 5.3 0 1.98 0.8 3.91 2.2 5.3 1.39 1.4 3.33 2.2 5.3 2.2z" />
          <path d="m455.5 103h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m439.5 312h-80c-12.958 0-23.5 10.542-23.5 23.5v56c0 12.958 10.542 23.5 23.5 23.5h80c12.958 0 23.5-10.542 23.5-23.5v-56c0-12.958-10.542-23.5-23.5-23.5zm8.5 79.5c0 4.687-3.813 8.5-8.5 8.5h-80c-4.687 0-8.5-3.813-8.5-8.5v-56c0-4.687 3.813-8.5 8.5-8.5h80c4.687 0 8.5 3.813 8.5 8.5v56z" />
          <path d="m359.5 231c12.958 0 23.5-10.542 23.5-23.5s-10.542-23.5-23.5-23.5-23.5 10.542-23.5 23.5 10.542 23.5 23.5 23.5zm0-32c4.687 0 8.5 3.813 8.5 8.5s-3.813 8.5-8.5 8.5-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5z" />
          <path d="m423.5 344h-48c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h48c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m399.5 368h-24c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h24c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m39.5 175h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m39.5 215h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m63.5 240h-8c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h8c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m39.5 295h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m87.5 175h32c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-32c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m87.5 295h64c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-64c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m87.5 215h80c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-80c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m95.5 240c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h32c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-32z" />
          <path d="m191 247.5c0-4.142-3.358-7.5-7.5-7.5h-24c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h24c4.142 0 7.5-3.358 7.5-7.5z" />
          <path d="m215.5 240c-1.97 0-3.91 0.8-5.3 2.2-1.4 1.39-2.2 3.33-2.2 5.3s0.8 3.91 2.2 5.3c1.39 1.4 3.33 2.2 5.3 2.2s3.91-0.8 5.3-2.2c1.4-1.39 2.2-3.33 2.2-5.3s-0.8-3.91-2.2-5.3c-1.39-1.4-3.33-2.2-5.3-2.2z" />
          <path d="m194.2 322.2c-1.4 1.39-2.2 3.33-2.2 5.3s0.8 3.91 2.2 5.3c1.39 1.4 3.33 2.2 5.3 2.2s3.91-0.8 5.3-2.2c1.4-1.39 2.2-3.33 2.2-5.3s-0.8-3.91-2.2-5.3c-1.39-1.4-3.32-2.2-5.3-2.2s-3.91 0.8-5.3 2.2z" />
          <path d="m63.5 320h-8c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h8c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m175 327.5c0-4.142-3.358-7.5-7.5-7.5h-72c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h72c4.142 0 7.5-3.358 7.5-7.5z" />
          <path d="m63.5 360h-8c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h8c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m95.5 360c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h48c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-48z" />
          <path d="m207 367.5c0-4.142-3.358-7.5-7.5-7.5h-24c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h24c4.142 0 7.5-3.358 7.5-7.5z" />
          <path d="m55.5 400h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m111.5 400h-24c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h24c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m223.5 400h-16c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h16c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path d="m151.5 175h64c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-64c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z" />
          <path d="m175.5 400h-32c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h32c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
          <path
            d="m471.5 56h-208.5v-16.5c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v16.5h-208.5c-21.78 0-39.5 17.72-39.5 39.5v320c0 21.78 17.72 39.5 39.5 39.5h208.5v16.5c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-16.5h208.5c21.78 0 39.5-17.72 39.5-39.5v-320c0-21.78-17.72-39.5-39.5-39.5zm0 15c13.509 0 24.5 10.991 24.5 24.5v24.5h-233v-17h160.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-160.5v-17h208.5zm-432 0h208.5v17h-128.5c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h128.5v17h-233v-24.5c0-13.509 10.991-24.5 24.5-24.5zm0 369c-13.509 0-24.5-10.991-24.5-24.5v-280.5h233v136.5 5e-3 168.5h-208.5zm223.5-113h32.5c4.687 0 8.5 3.813 8.5 8.5v56c0 4.687-3.813 8.5-8.5 8.5h-32.5v-73zm0-52.394l48.5-48.5 42.697 42.697c2.929 2.929 7.678 2.929 10.606 0l83.197-83.197v85.894c0 4.687-3.813 8.5-8.5 8.5h-176.5v-5.394zm96.5-21.712l-42.697-42.697c-2.929-2.929-7.678-2.929-10.606 0l-43.197 43.197v-78.394h174.39l-77.894 77.894zm112 187.11h-208.5v-25h32.5c12.958 0 23.5-10.542 23.5-23.5v-56c0-12.958-10.542-23.5-23.5-23.5h-32.5v-17h176.5c12.958 0 23.5-10.542 23.5-23.5v-88c0-12.958-10.542-23.5-23.5-23.5h-176.5v-25h233v280.5c0 13.509-10.991 24.5-24.5 24.5z"
            fill="#333"
          />
        </svg>
      </figure>
      <div>
        <h4>Programming Skills</h4>
        <p>
          I always develop myself and every day I learn something new,Learning
          From cradle to grave
        </p>
        <article className="skill-list">
          <p>
            "HTML5" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "CSS/SASS" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "JavaScript" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "React.js" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "Redux.js" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "Vue.js" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "Jquery" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "GraphQl" :
            <span className="skill">
              <i />
            </span>
          </p>

          <p>
            "Bootstrap" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            "Node.js" :
            <span className="skill">
              <i />
              <i />
            </span>
          </p>

          <p>
            "MY-SQL" :
            <span className="skill">
              <i />
              <i />
            </span>
          </p>

          <p>
            "Laravel" :
            <span className="skill">
              <i />
            </span>
          </p>
          <p>
            "NPM & Yarn" :
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>
        </article>
      </div>
    </section>
  );
};

export default Skills;
